import tonStyles from './../ton.json'

const primaryWhiteLink = {
  color: tonStyles.colors.PrimaryWhite,
  borderBottom: `1px solid ${tonStyles.colors.PrimaryWhite}`
}

export default {
  name: '4',
  type: 'Paragraph',
  default: {
    color: tonStyles.colors.PrimaryBlack,
    borderBottom: `1px solid ${tonStyles.colors.PrimaryBlack}`
  },
  hover: {
    color: tonStyles.colors.SecondaryMidGrey,
    borderBottom: `1px solid ${tonStyles.colors.SecondaryMidGrey}`
  },
  inverseDefault: primaryWhiteLink,
  inverseHover: primaryWhiteLink
}
